<template>
  <div>
      <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">X</v-btn>
    </v-snackbar>
      <br>
      <v-data-table
            :headers="headers"
            hide-default-footer
            :items="listReport"
            class="elevation-1"
        >
            <template v-slot:[`item.tgl_laporan`]="{ item }">
                <div>
                    {{ item.tgl_laporan | dateTimeFormat }} WIB
                </div>
            </template>
        </v-data-table>
        <br>
        <v-card-actions v-if="from == 'laporan'">
            <v-spacer></v-spacer>
            <v-btn color="#e9f4f5" @click="dialogToPantau = true" style="color:#c90000">Pantau Iklan</v-btn>
            <v-btn color="#c90000" @click="dialogBekukan = true" class="white--text">Bekukan Iklan</v-btn>
        </v-card-actions>
        <v-card-actions v-if="from == 'pantau'">
            <v-spacer></v-spacer>
            <v-btn color="#e9f4f5" @click="dialogToNormal = true" style="color:#c90000">Tayangkan Iklan</v-btn>
            <v-btn color="#c90000" @click="dialogBekukan = true" class="white--text">Bekukan Iklan</v-btn>
        </v-card-actions>

        <v-dialog v-model="dialogToPantau" max-width="600px">
            <v-card>
                <v-toolbar flat dense color="#c90000">
                    <v-toolbar-title dark><b>Anda yakin ingin memantau Iklan ini ? </b></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogToPantau = false,alasanToPantau = ''">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <br />
                <div class="mx-3">
                    <h3>Masukkan alasan Anda memantau iklan ini</h3>
                    <v-textarea
                        solo
                        label="Alasan"
                        v-model="alasanToPantau"
                    ></v-textarea>
                </div>
                <v-card-actions>
                <v-spacer />
                
                <v-btn
                    dense
                    small
                    outlined
                    @click="dialogToPantau = false,alasanToPantau = ''"
                >
                    cancel
                </v-btn>
                <v-btn  dense @click="pantauIklan()" small class="white--text" color="#c90000" :disabled="alasanToPantau == '' ? true : false">
                    Pantau
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogToNormal" max-width="600px">
            <v-card>
                <v-toolbar flat dense color="#c90000">
                    <v-toolbar-title dark><b>Anda yakin ingin menayangkan kembali Iklan ini ? </b></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogToNormal = false,alasanToNormal = ''">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <br />
                <div class="mx-3">
                    <h3>Masukkan alasan Anda menayangkan kembali iklan ini</h3>
                    <v-textarea
                        solo
                        label="Alasan"
                        v-model="alasanToNormal"
                    ></v-textarea>
                </div>
                <v-card-actions>
                <v-spacer />
                
                <v-btn
                    dense
                    small
                    outlined
                    @click="dialogToNormal = false,alasanToNormal = ''"
                >
                    cancel
                </v-btn>
                <v-btn  dense @click="normalIklan()" small class="white--text" color="#c90000" :disabled="alasanToNormal == '' ? true : false">
                    Tayangkan
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogBekukan" max-width="600px">
            <v-card>
                <v-toolbar flat dense color="#c90000">
                    <v-toolbar-title dark><b>Anda yakin ingin membekukan Iklan ini ? </b></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogBekukan = false,alasanToBekukan = ''">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <br />
                <div class="mx-3">
                    <h3>Masukkan alasan mengapa iklan dibekukan</h3>
                    <v-textarea
                        solo
                        label="Alasan"
                        v-model="alasanToBekukan"
                    ></v-textarea>
                </div>
                <v-card-actions>
                <v-spacer />
                
                <v-btn
                    dense
                    small
                    outlined
                    @click="dialogBekukan = false,alasanToBekukan = ''"
                >
                    cancel
                </v-btn>
                <v-btn @click="bekukanIklan()" class="white--text" dense small  color="#c90000" :disabled="alasanToBekukan == '' ? true : false">
                    Bekukan
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['idIklan'],
    name: 'ListIklan',
    data: () => ({
        color: { snackbar: '' },
        snackbar: false,
        message: null,
        headers: [
            { text: "Nama Pelapor", value: "nama_user" },
            { text: "Jenis Laporan", value: "jenis_report" },
            { text: "Alasan Laporan", value: "alasan_report" },
            { text: "Tanggal Laporan", value: "tgl_laporan" },
        ],
        listReport:[],
        listPantau:[],
        from:'',
        dialogToPantau:false,
        dialogBekukan:false,
        dialogToNormal:false,
        alasanToPantau:'',
        alasanToNormal:'',
        alasanToBekukan:'',
        idAdmin:'',
    }),
    methods: {
        async getListReport() {
            await this.$req
                .get(this.$root.$baseapi.iklan+'/iklan/v3/list_laporan_iklan_pengguna', {
                params: {
                    id_iklan: this.idIklan,
                },
                })
                .then((response) => {
                    this.listReport = response.data.data
                    console.log('listReport',this.listReport)
                })
                .catch((error) => {
                let responses = error.response.data
                console.log(responses.api_message)
                })
        },
        async getListPantau() {
            await this.$req
                .get(this.$root.$baseapi.iklan+'/iklan/v3/list_pantau_iklan_alasan', {
                    params: {
                        id_iklan: this.idIklan,
                    },
                })
                .then((response) => {
                    this.listPantau = response.data.data
                    console.log('listPantau',this.listPantau)
                })
                .catch((error) => {
                    let responses = error.response.data
                    console.log(responses.api_message)
                })
        },
        async pantauIklan(){
            console.log('id iklan', this.idIklan)
            console.log('id user', this.idAdmin)
            console.log('alasan', this.alasanToPantau)

            let formData = new FormData();
            formData.append('id_biz_user', this.idAdmin);
            formData.append('alasan', this.alasanToPantau);
            formData.append('id_iklan', this.idIklan)

            this.$req
                .post(this.$root.$baseapi.iklan+'/iklan/v3/pantau_iklan_status', formData)
                .then(response => {
                    this.snackbar = true;
                    this.message = response.data.api_message;
                    this.color.snackbar = 'success';
                    this.$router.push('/list_iklan?tab=dipantau')
                    console.log(response.data.api_message)
                })
                .catch(error => {
                    let responses = error.response.data;
                    this.snackbar = true;
                    this.message = responses.api_message;
                    this.color.snackbar = 'error';
                    console.log(responses)
                });
        },
        async bekukanIklan(){
            console.log('id iklan', this.idIklan)
            console.log('id user', this.idAdmin)
            console.log('alasan', this.alasanToBekukan)

            let formData = new FormData();
            formData.append('id_biz_user', this.idAdmin);
            formData.append('alasan', this.alasanToBekukan);
            formData.append('id_iklan', this.idIklan)

            this.$req
                .post(this.$root.$baseapi.iklan+'/iklan/v3/take_down_iklan', formData)
                .then(response => {
                    this.snackbar = true;
                    this.message = response.data.api_message;
                    this.color.snackbar = 'success';
                    this.$router.push('/list_iklan?tab=beku')
                    console.log(response)
                })
                .catch(error => {
                    let responses = error.response;
                    this.snackbar = true;
                    this.message = responses.data.api_message;
                    this.color.snackbar = 'error';
                    console.log(responses)
                });
        },
        async normalIklan(){
            console.log('id iklan', this.idIklan)
            console.log('id user', this.idAdmin)
            console.log('alasan', this.alasanToNormal)

            let formData = new FormData();
            formData.append('id_biz_user', this.idAdmin);
            formData.append('alasan', this.alasanToNormal);
            formData.append('id_iklan', this.idIklan)

            this.$req
                .post(this.$root.$baseapi.iklan+'/iklan/v3/pantau_iklan_status_normal', formData)
                .then(response => {
                    this.snackbar = true;
                    this.message = response.data.api_message;
                    this.color.snackbar = 'success';
                    this.$router.push('/list_iklan?tab=aktif')
                    console.log(response.data.api_message)
                })
                .catch(error => {
                    let responses = error.response.data;
                    this.snackbar = true;
                    this.message = responses.api_message;
                    this.color.snackbar = 'error';
                    console.log(responses)
                });
        },
    },
    async created(){
        this.getListReport()
        this.getListPantau()
        this.from = this.$route.query.from
        this.idAdmin = localStorage.getItem('id')
    },
    filters: {
        countDoc(doc) {
        if (doc !== null) {
            return true;
        }
        },
        datediff: date => {
        return moment(date).from();
        },
        dateFormat: date => {
        return moment.utc(date).format('DD MMM YYYY');
        },
        timeFormat: date => {
        return moment.utc(date).format('HH:mm');
        },
        dateTimeFormat: date => {
        return moment.utc(date).format('DD MMM YYYY HH:mm');
        }
    },
}
</script>

<style>
.v-data-table-header {
  background: #EBF0F4;
}
tbody tr:nth-of-type(even) {
  background-color: #EBF0F4;
}

tbody tr:nth-of-type(odd) {
  background-color: #ffffff;
}
.v-data-footer {
  background-color: rgb(250, 250, 250);
}
</style>